import { IconButton, IconButtonProps } from '@mui/material';
import { forwardRef } from 'react';

export type MHMIconButtonProps = IconButtonProps;

export const MHMIconButton = forwardRef(function MHMIconButton(
  props: MHMIconButtonProps,
  ref: React.ForwardedRef<HTMLButtonElement>,
) {
  const { children, ...rest } = props;
  return (
    <IconButton ref={ref} {...rest}>
      {children}
    </IconButton>
  );
});
